import styled from 'styled-components';
import wixService from '../../../services/wixService';

function getMobileTitleFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.titleFontSize + 'px !important'
    : '';
}

export const EmptyStateContainerBlock = styled.div`
  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: ${(props) =>
      wixService.getColorByreference(props.design.headerText.color.value)};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.headerText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(props.design.headerText.font.value)};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.headerText.font.name,
      )};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.headerText.font.name,
      )} !important;
    text-align: center;
  }
`;
